var React = require('react');

function ArrowDownW (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.80129 5.46812C2.98101 5.2884 3.27238 5.2884 3.4521 5.46812L8.33317 10.3492L13.2142 5.46812C13.394 5.2884 13.6853 5.2884 13.8651 5.46812C14.0448 5.64783 14.0448 5.93921 13.8651 6.11893L8.65858 11.3254C8.47886 11.5051 8.18748 11.5051 8.00777 11.3254L2.80129 6.11893C2.62157 5.93921 2.62157 5.64784 2.80129 5.46812Z","fill":"white"}));
}

ArrowDownW.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowDownW;

ArrowDownW.default = ArrowDownW;
